module.exports = __webpack_public_path__ + "img/clouds-rest-2.9d91f5e8.jpg";